import { Maybe } from 'graphql/jsutils/Maybe';
import {
  CashbackFinanceOffer,
  CashbackFinanceOfferViewModel_CheckoutDisplay,
  EverydayFinanceOffer,
  //   TODO:: IN STORE Offers - LIMITED
  //   LimitedTimeFinancingOffer,
  //   LimitedTimeFinancingOfferViewModel_CheckoutDisplay,
  //   LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer,
  LowCostFinancingOffer,
  SpecialFinancingOffer,
  SpecialFinancingOfferViewModel_CheckoutDisplay,
} from '~/gql/__generated__/types';

export interface IFinancingOfferFormatted {
  lowCostOfferDetailsOnCart?: string; // RichText
  numOfMonths?: number | null;
  costPerMonth?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  //   TODO:: IN STORE Offers - LIMITED
  //   isLTO?: boolean | null;
  monthlyOfferDetails?: string | null; // RichText
  minPurchase?: number | null;
  lowCostFinancingOfferMessage?: string | null;
  everydayFinancingOfferMessage?: string | null;
  //   TODO:: IN STORE Offers - LIMITED
  //   limitedFinancingOfferMessage?: string | null;
  cashbackFinancingOfferMessage?: string | null;
  financingOfferDescription?: string | null; // RichText
  disclaimer?: string | null; // RichText
  specialCampaign?: IFinancingOfferCampaign | null;
  //   TODO:: IN STORE Offers - LIMITED
  // | Maybe<LimitedTimeFinancingOfferViewModel_SpecialCampaignOffer>;
  offerName?: string | null;
  checkoutDisplay?:
    | { heading: string; details: string; specialOffer?: string }
    | null
    // | Maybe<LimitedTimeFinancingOfferViewModel_CheckoutDisplay>
    | Maybe<SpecialFinancingOfferViewModel_CheckoutDisplay>
    | Maybe<CashbackFinanceOfferViewModel_CheckoutDisplay>
    | undefined;
  FinancingOfferDataOnPage?: string | null; // RichText
  isCashBack?: boolean | null;
  cashBackPercentageAmount?: number | null;
  cashbackBannerDetails?: string | null; // RichText
  planID?: Maybe<string>;
  isEverydayOffer?: boolean;
  maxPurchase?: Maybe<number>;
  syfModalHeading?: string | null;
  syfModalSubHeading?: string | null;
  additionalContentCreditCardOffer?: Array<string | null> | null;
  financeOfferModalLabel?: string | null;
}

export interface IFinancingOfferCampaign {
  campaignName: string;
  initialMonthlyAmount: number;
  numOfDiscountedMonths: number;
  campaignValidStartDate: string;
  campaignValidEndDate: string;
  enableCampaign: boolean;
  showEverydayFlag: boolean;
}

export interface ISelectFinancingOfferData {
  //   TODO:: IN STORE Offers - LIMITED
  //   limitedTimeFinancingOffers:
  //     | Maybe<Maybe<LimitedTimeFinancingOffer>[]>
  //     | undefined;
  everydayFinancingOffers: Maybe<Maybe<EverydayFinanceOffer>[]> | undefined;
  lowCostFinancingOffers?: Maybe<Maybe<LowCostFinancingOffer>[]> | undefined;
  totalPrice: number | undefined;
  specialFinancingOffer?: Maybe<Maybe<SpecialFinancingOffer>[]> | undefined;
  specialFinancingEnable?: boolean;
  checkoutShowEveryDayOffers?: boolean;
  cashbackFinancingEnable?: boolean;
  cashBackFinancingOffer?: Maybe<Maybe<CashbackFinanceOffer>[]> | undefined;
}

export interface ICampaignRemainingCost {
  cost: number;
  months: number;
}

export interface ISynchronyOffer {
  isOfferFound: boolean;
  campaignFound: IFinancingOfferFormatted | undefined;
  bestSynchronyOffer: IFinancingOfferFormatted;
  everyDayOffersForCheckout?: IFinancingOfferFormatted[];
}

export const synchronyDateFormat = 'M/D/YYYY';
